const getFieldOfWorkOptions = (t) => [
    {
        label: t('field_of_work_choice_1'),
        value: 'Agriculture',
    },
    {
        label: t('field_of_work_choice_2'),
        value: 'Architecture',
    },
    {
        label: t('field_of_work_choice_3'),
        value: 'Arts',
    },
    {
        label: t('field_of_work_choice_5'),
        value: 'Construction',
    },
    {
        label: t('field_of_work_choice_6'),
        value: 'Culinary',
    },
    {
        label: t('field_of_work_choice_7'),
        value: 'Education',
    },
    {
        label: t('field_of_work_choice_8'),
        value: 'Engineering',
    },
    {
        label: t('field_of_work_choice_9'),
        value: 'Finance',
    },
    {
        label: t('field_of_work_choice_10'),
        value: 'Government',
    },
    {
        label: t('field_of_work_choice_11'),
        value: 'Healthcare',
    },
    {
        label: t('field_of_work_choice_12'),
        value: 'Information Technology',
    },
    {
        label: t('field_of_work_choice_13'),
        value: 'Legal',
    },
    {
        label: t('field_of_work_choice_14'),
        value: 'Logistics',
    },
    {
        label: t('field_of_work_choice_15'),
        value: 'Manufacturing',
    },
    {
        label: t('field_of_work_choice_16'),
        value: 'Media',
    },
    {
        label: t('field_of_work_choice_17'),
        value: 'Others',
    },
    {
        label: t('field_of_work_choice_18'),
        value: 'Personal Care',
    },
    {
        label: t('field_of_work_choice_19'),
        value: 'Science',
    },
    {
        label: t('field_of_work_choice_20'),
        value: 'Social Services',
    },
    {
        label: t('field_of_work_choice_21'),
        value: 'Retired',
    },
    {
        label: t('field_of_work_choice_22'),
        value: 'At-Home Trader With No Other Occupation',
    },
    {
        label: t('field_of_work_choice_23'),
        value: 'Student/Intern',
    },
    {
        label: t('field_of_work_choice_24'),
        value: 'Homemaker',
    },
    {
        label: t('field_of_work_choice_25'),
        value: 'Unemployed',
    },
];

export default getFieldOfWorkOptions;
